
import simple_select from './simple_select.js';
import direct_select from './direct_select.js';
import draw_point from './draw_point.js';
import draw_polygon from './draw_polygon.js';
import draw_line_string from './draw_line_string.js';

export default {
  simple_select,
  direct_select,
  draw_point,
  draw_polygon,
  draw_line_string,
};
